import { useCallback, useEffect, useState } from 'react';
import { Direction, ScrollamaType } from '../models';
import { SCROLL_TRIGGER_OFFSET } from '../constants';

const ROOT_SCROLL_TRIGGER_OFFSET = 0.5

export function useSteps(stepCount: number, forRoot = false) {
  const [isActive, setIsActive] = useState(false);
  const [step, setStep] = useState(0);
  const [direction, setDirection] = useState(Direction.Down);

  function handleOnStepEnter({ data, direction }: ScrollamaType) {
    setIsActive(true);
    setStep(data);
    setDirection(direction);
  }

  function handleOnStepExit({ data, direction }: ScrollamaType) {
    if (
      (stepCount - 1 === data && direction === Direction.Down) ||
      (!data && direction === Direction.Up)
    ) {
      setIsActive(false);
    }
  }

  return {
    isActive,
    step,
    direction,
    offset: forRoot
      ? ROOT_SCROLL_TRIGGER_OFFSET : SCROLL_TRIGGER_OFFSET,
    handleOnStepEnter,
    handleOnStepExit
  }
}

export function useHash(): [string, (hash: string) => void] {
  const [hash, setHash] = useState(() => window.location.hash);

  const hashChangeHandler = useCallback(() => {
    setHash(window.location.hash);
  }, []);

  useEffect(() => {
    window.addEventListener('hashchange', hashChangeHandler);
    return () => {
      window.removeEventListener('hashchange', hashChangeHandler);
    };
  }, []);

  const updateHash = useCallback(
    (newHash: string) => {
      if (newHash !== hash) window.location.hash = newHash;
    },
    [hash]
  );

  return [hash, updateHash];
};